export default __webpack_public_path__ + "static/media/2.67192471.svg";